import React from 'react';
import 'styles/common.css';
import './Partnerships.css';

const Partnerships = () => {
  const partners = [
    { name: 'Berkeley University of California', logo: '/partnershipLogos/berkeley-university-of-california.png' },
    { name: 'Broad Institute', logo: '/partnershipLogos/broad-institute.png' },
    { name: 'City of Hope', logo: '/partnershipLogos/city-of-hope.png' },
    { name: 'Cleveland Clinic', logo: '/partnershipLogos/cleveland-clinic.png' },
    { name: 'Fred Hutch Cancer Center', logo: '/partnershipLogos/fred-hutch-cancer-center.png' },
    { name: 'Harvard Medical School', logo: '/partnershipLogos/harvard-medical-school.png' },
    { name: 'Johns Hopkins Medicine', logo: '/partnershipLogos/johns-hopkins-medicine.png' },
    { name: 'Mass General Brigham', logo: '/partnershipLogos/mass-general-brigham.png' },
    { name: 'Mayo Clinic', logo: '/partnershipLogos/mayo-clinic.png' },
    { name: 'MD Anderson Center', logo: '/partnershipLogos/md-anderson-center.png' },
    { name: 'Memorial Sloan Kettering', logo: '/partnershipLogos/memorial-sloan-kettering.png' },
    { name: 'National Institutes of Health', logo: '/partnershipLogos/nih.png' },
    { name: 'NYU Langone Health', logo: '/partnershipLogos/nyu-langone-health.png' },
    { name: 'Ocular Therapeutix', logo: '/partnershipLogos/ocular-therapeutix.png' },
    { name: 'Precigen', logo: '/partnershipLogos/precigen.png' },
    { name: 'Rutgers', logo: '/partnershipLogos/rutgers.png' },
    { name: 'The Rockefeller University', logo: '/partnershipLogos/the-rockefeller-university.png' },
    { name: 'Thermo Fisher Scientific', logo: '/partnershipLogos/thermo-fisher-scientific.png' },
    { name: 'United Therapeutics', logo: '/partnershipLogos/united-therapeutics.png' },
    { name: 'University of Arkansas', logo: '/partnershipLogos/university-of-arkansas.png' },
    { name: 'University of Pittsburgh', logo: '/partnershipLogos/university-of-pittsburgh.png' },
    { name: 'US Food & Drug Administration', logo: '/partnershipLogos/us-food-and-drug-administration.png' }
  ];

  return (
    <div className="partnerships-page">
      {/* Header Section */}
      <div className="partnerships-hero">
        <div className="partnerships-hero-content">
          <h1 className="partnerships-title">
            Our <span className="gradient-text">Partnerships</span>
          </h1>
          <p className="partnerships-subtitle">
            Collaborating with leading institutions and organizations to advance AI-driven drug discovery and quantum mechanics research
          </p>
          <div className="partnerships-stats">
            <div className="partnership-stat">
              <span className="stat-number">{partners.length}+</span>
              <span className="stat-label">Leading Partners</span>
            </div>
            <div className="partnership-stat">
              <span className="stat-number">Global</span>
              <span className="stat-label">Collaborations</span>
            </div>
            <div className="partnership-stat">
              <span className="stat-number">Innovation</span>
              <span className="stat-label">Driven</span>
            </div>
          </div>
        </div>
      </div>

      {/* Partnerships Grid */}
      <div className="partnerships-container">
        <div className="partnerships-grid">
          {partners.map((partner, index) => (
            <div key={index} className="partner-card">
              <div className="partner-logo-container">
                <img 
                  src={partner.logo} 
                  alt={`${partner.name} logo`}
                  className="partner-logo"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="partner-fallback">
                  {partner.name}
                </div>
              </div>
              <div className="partner-name">{partner.name}</div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div className="partnerships-cta">
        <div className="partnerships-cta-content">
          <h2>Interested in Partnering With Us?</h2>
          <p>Join our network of innovative organizations working together to transform drug discovery</p>
          <button className="btn btn-primary btn-large">
            Become a Partner
          </button>
        </div>
      </div>
    </div>
  );
};

export default Partnerships;